"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var HeaderConfig_1 = require("../common/HeaderConfig/HeaderConfig");

var StyledComponents_1 = require("../Header/Helpers/StyledComponents");

var StyledComponents_2 = require("./Helpers/StyledComponents");

var PhoneLinkRenderer_1 = require("../Renderers/PhoneLinkRenderer");

var FooterTermsPrivacyLinks_1 = require("../Renderers/FooterTermsPrivacyLinks");

var Constants_1 = require("../common/Constants");

var frontend_application_1 = require("@ryerson/frontend.application");

var Footer = function Footer(_ref) {
  var _ref$storeDirectory = _ref.storeDirectory,
      storeDirectory = _ref$storeDirectory === void 0 ? Constants_1.STORE : _ref$storeDirectory,
      companyName = _ref.companyName;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      secondaryBrand = _theme$colors$primary.secondaryBrand,
      lighterGray = _theme$colors$primary.lighterGray;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      country = _ref3.localization.country;

  var headerSettings = HeaderConfig_1.headerConfigData[companyName];
  return (0, jsx_runtime_1.jsxs)("div", {
    className: "simple-footer",
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      lessThan: "lg",
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        alignContent: "center",
        alignItems: "center",
        css: (0, StyledComponents_2.footerStyle)({
          backColor: secondaryBrand,
          borderColor: lighterGray,
          height: 90
        }),
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Container, {
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            direction: "column",
            justifyContent: "space-between",
            alignItems: "flex-start",
            className: "outer-text-wrapper",
            children: [(0, PhoneLinkRenderer_1.renderPhoneLink)(headerSettings, country, "tertiary", "lg"), (0, jsx_runtime_1.jsx)(StyledComponents_2.FootDivider, {
              color: lighterGray
            }), (0, FooterTermsPrivacyLinks_1.FooterTermsPrivacyLinksRenderer)(theme, true)]
          })
        })
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.Media, {
      greaterThanOrEqual: "lg",
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        alignContent: "center",
        alignItems: "center",
        css: (0, StyledComponents_2.footerStyle)({
          backColor: secondaryBrand,
          borderColor: lighterGray,
          height: 90
        }),
        children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Container, {
          children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            justifyContent: "space-between",
            alignItems: "center",
            className: "outer-text-wrapper",
            children: [(0, FooterTermsPrivacyLinks_1.FooterTermsPrivacyLinksRenderer)(theme), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              style: StyledComponents_1.phoneLinkWrapperStyle,
              children: (0, PhoneLinkRenderer_1.renderPhoneLink)(headerSettings, country, "tertiary", "lg")
            })]
          })
        })
      })
    })]
  });
};

exports.default = Footer;